import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import {
  academylist,
  feedashcount,
  feeinvoicelist,
  feereportlist,
} from "../../../services/admin";
import moment from "moment";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stufeetypelist,
} from "../../../services/master";

export default function FeeReport() {
  const navigate = useNavigate();
  const [feedata, setFeeData] = useState([]);
  const [feelist, setFeeList] = useState([]);
  const [aclist, setAcList] = useState([]);

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [stusec, setStuSec] = useState("");
  const [seclist, setSecList] = useState([]);
  const [ayear, setAYear] = useState("");

  const [flist, setFlist] = useState([]);
  const [ftype, setFType] = useState("");

  const [rtype, setRType] = useState("1");


  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyear(arr[0]);
              }
            }
          }
        }
      });
    }

    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSecList(arr);
        }
      }
    });

    if (localStorage.getItem("ADate") !== "") {
      setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      listall(
        "",
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), "", "", "", "", 1,
      );
    } else {
      setFDate(moment(new Date()).format("YYYY-MM-DD"));
      setTDate(moment(new Date()).format("YYYY-MM-DD"));
      listall(
        "",
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"), "", "", "", "", 1,
      );
    }
  }, []);

  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });

    stufeetypelist(temp).then((res) => {
      if (res.status === true) {
        setFlist(res.data);
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
      listall(e, fdate, tdate, ayear, stucls, stusec, ftype, rtype);
    } else {
      setAcaID("");
      listyear("");
      listall("", fdate, tdate, ayear, stucls, stusec, ftype, rtype);
    }
  }

  function listall(aid, fdte, tdte, ayr, scls, ssec, ftye, rtye) {
    setFeeData([]);
    setFeeList([]);
    setFDate(fdte);
    setTDate(tdte);
    setAYear(ayr);
    setStuCls(scls);
    setStuSec(ssec);
    setFType(ftye);
    setRType(rtye);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("from_date", fdte);
    temp.append("to_date", tdte);
    temp.append("year_id", ayr);
    temp.append("class_id", scls);
    temp.append("section_id", ssec);
    temp.append("feetype", ftye);
    temp.append("type", rtye);

    feereportlist(temp).then((res) => {
      if (res.status === true) {
        const arr = res.data.map((item, index) => ({
          ...item,
          paid_date: item.paid_date !== null ? moment(item.paid_date).format("DD-MM-YYYY") : "",
          due_date: item.due_date !== null ? moment(item.due_date).format("DD-MM-YYYY") : "",
          fee_month: item.fee_month ? moment(item.fee_month, "YYYY-MM").format("MMM YYYY") : "",

        }))
        setFeeList(arr);
      }
    })
  }

  const columnDefs = [
    {
      headerName: "Date",
      field: "paid_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academic Year",
      field: "aca_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Photo",
      field: "photo",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              <img
                src={params.data.path + params.value}
                style={{ width: "50px", height: "50px" }}
                className="img-circle"
                onError={(ev) => errorphoto(ev)}
              />
            </div>
          );
        } else {
          return (
            <div className="text-center">
              <img
                src={require("../../../assets/images/user.png")}
                style={{ width: "50px", height: "50px" }}
                className="img-circle"
                onError={(ev) => errorphoto(ev)}
              />
            </div>
          );
        }

      },
      valueGetter: function (params) {
        return params.data.photo ? `${params.data.path}${params.data.photo}` : "";
      }
    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Total Amount",
      field: "total_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Paid Amount",
      field: "paid_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Discount Amount",
      field: "disc_amt",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Pending Amount",
      field: "pending_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Fee Type",
      field: "fee_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Month",
      field: "fee_month",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Due Date",
      field: "due_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }
  const gridRef = useRef(null);

  const downloadExcel = () => {
    gridRef.current.api.exportDataAsCsv({
      fileName:rtype == "1" ? "Fee Collection Report.csv" : rtype == "2" ? "Outstanding Report.csv" : rtype == "3" ? "Student Discount Report.csv" : "Fee Report.csv",
      processCellCallback: (params) => {
        if (params.column.getColId() === "photo") {
          const photoUrl = params.value;
          return photoUrl ? `=HYPERLINK("${photoUrl}", "View Photo")` : '';
        }
        return params.value;
      },
    });
  };
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Fee Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Fee Report
          </li>
        </ol>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                {localStorage.getItem("Role") === "1" && (
                  <Col xxl={4} lg={4} md={4}>
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={aclist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />
                    </div>
                  </Col>
                )}
                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">Academic Year</label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => {
                      listall(acaid, fdate, tdate, e.target.value, stucls, stusec, ftype, rtype);
                    }}
                    value={ayear}
                  >
                    <option value="" disabled>
                      Select Academic Year
                    </option>
                    {alist.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">
                    Select Class{/* <span className="text-danger"> *</span> */}
                  </label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => {
                      listall(acaid, fdate, tdate, ayear, e.target.value, stusec, ftype, rtype);
                    }}
                    value={stucls}
                  >
                    <option value="" disabled>
                      Select Class
                    </option>
                    {clist.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">
                    Section{/* <span className="text-danger"> *</span> */}
                  </label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => {
                      listall(acaid, fdate, tdate, ayear, stucls, e.target.value, ftype, rtype);
                    }}
                    value={stusec}
                  >
                    <option value="" disabled>
                      Select Section
                    </option>
                    {seclist.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">Fee Type</label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => {
                      listall(acaid, fdate, tdate, ayear, stucls, stusec, e.target.value, rtype);
                    }}
                    value={ftype}
                  >
                    <option value="" disabled>
                      Select Fee Type
                    </option>
                    {flist.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.fee_type}
                      </option>
                    ))}
                  </select>
                </Col>

                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">Type</label>
                  <select
                    className="default-select form-control wide"
                    onChange={(e) => {
                      listall(acaid, fdate, tdate, ayear, stucls, stusec, ftype, e.target.value);
                    }}
                    value={rtype}
                  >
                    <option value="" disabled>
                      Select Type
                    </option>
                    <option value="1">Fee Collection Report</option>
                    <option value="2">Outstanding Report</option>
                    <option value="3">Discount student Report</option>
                  </select>
                </Col>

                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, e.target.value, tdate, ayear, stucls, stusec, ftype, rtype)}
                    value={fdate}
                  />
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, fdate, e.target.value, ayear, stucls, stusec, ftype, rtype)}
                    value={tdate}
                  />
                </Col>
                {localStorage.getItem("Role") === "1" ? (
                  <Col xxl={4} lg={4} md={4}>
                    <div className="text-end mt-5">
                      <a className="btn btn-success" onClick={downloadExcel}> Export</a>
                    </div>
                  </Col>
                ) : (
                  <Col xxl={8} lg={8} md={8}>
                    <div className="text-end mt-5">
                      <a className="btn btn-success" onClick={downloadExcel}> Export</a>
                    </div>
                  </Col>
                )}
              </Row>

              <div className="ag-theme-alpine ag-style  mt-2">
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columnDefs}
                  rowData={feelist}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
